// node modules styles
require('quill/dist/quill.snow.css')
require('font-awesome/css/font-awesome.css')
require('@fortawesome/fontawesome-pro/css/fontawesome.min.css')
require('@fortawesome/fontawesome-pro/css/all.min.css')
require('bootstrap/dist/css/bootstrap.css')
require('angular-loading-bar/build/loading-bar.css')

// application styles
require('css/admin-bootstrap-theme.css')
require('css/admin-style.scss')

// colorpicker style
require('angular-bootstrap-colorpicker/css/colorpicker.css')
require('angularjs-dragula/dist/dragula.min.css')

// icon for apple
require('apple-touch-icon.png')

// require all angular templates (any .html file, except index.html)
var req = require.context('../../', true, /^(?:(?!index\.html$).)*\.html$/)
req.keys().forEach(req)
